var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"d-flex align-items-center ml-2",staticStyle:{"gap":"0.3rem"}},[_c('b-spinner',{attrs:{"variant":"secondary","small":"","label":"Please wait..."}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }